import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import "../../assets/css/corporate.css";
import data from "../ApiUrl/meta_api.js";

// ── Hero Background Image ─────────────────────────────────────
import corporate_bg from "../../assets/img/Course/Corprate training/people-taking-part-business-event.webp";
import corporate_about from "../../assets/img/Course/Corprate training/c8.webp";
import digital_img from "../../assets/img/Course/Corprate training/pexels-artempodrez-5716001.webp";
import training_img from "../../assets/img/Course/workshop/corprate-training.jpg";

//Icons And Images
import custamize_modulo from "../../assets/icons/excellence.png";
import industry_export from "../../assets/icons/career/certificate.png";
import hands_on from "../../assets/icons/career/Maintenance-icon.png";
import latest_tech from "../../assets/icons/career/Data Analytics.png";
import flexiable_train from "../../assets/icons/hands-on-lab.png";
import post_traine from "../../assets/icons/integrity.png";
import plc_program from "../../assets/icons/plc-program.png";
import scada_icon from "../../assets/icons/SCADA-icon.png";
import hmi_icon from "../../assets/icons/career/HMI Interface.png";
import automation_itegration from "../../assets/icons/iot-icon.png";
import trouble_shoot from "../../assets/icons/career/job-portal-icon.png";
import seo from "../../assets/icons/career/SEO Techniques.png";
import social_media from "../../assets/icons/career/Social Media Marketing.png";
import ppc from "../../assets/icons/innovation.png";
import content from "../../assets/icons/career/it-icon.png";
import email_icon from "../../assets/icons/career/mail Campaign Management.png";

// ================================================================
//  FRAMER-MOTION VARIANTS (same as Workshop)
// ================================================================
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

// const fadeRight = {
//   hidden: { opacity: 0, x: 60 },
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: { duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] },
//   },
// };

const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1 },
  },
};

const cardPop = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const zoomIn = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

// Viewport: animate once when 15% visible
const VP = { once: true, amount: 0.15 };

// ================================================================
//  DATA
// ================================================================

const whyChoose = [
  {
    icon: custamize_modulo,
    title: "Customised Modules",
    desc: "Training programs built around your company's exact requirements and skill gaps.",
  },
  {
    icon: industry_export,
    title: "Industry-Expert Trainers",
    desc: "Learn from professionals with real-time project experience across automation and marketing.",
  },
  {
    icon: hands_on,
    title: "Hands-On Sessions",
    desc: "Practical training with live tools, equipment, and real industry scenarios.",
  },
  {
    icon: latest_tech,
    title: "Latest Technologies",
    desc: "Curriculum updated with the newest tools, trends, and industry standards.",
  },
  {
    icon: flexiable_train,
    title: "Flexible Training Modes",
    desc: "Choose from Online, Offline, or On-site training based on your team's needs.",
  },
  {
    icon: post_traine,
    title: "Post-Training Support",
    desc: "Continued consultation and guidance even after the program concludes.",
  },
];

const automationModules = [
  {
    icon: plc_program,
    title: "PLC Programming",
    desc: "Comprehensive sessions on Mitsubishi, Siemens, and Allen-Bradley PLCs.",
  },
  {
    icon: scada_icon,
    title: "SCADA Systems",
    desc: "Mastery of real-time data monitoring and control systems.",
  },
  {
    icon: hmi_icon,
    title: "HMI Design",
    desc: "Building user-friendly interfaces for industrial applications.",
  },
  {
    icon: automation_itegration,
    title: "Automation Integration",
    desc: "Strategies for integrating automation into existing workflows.",
  },
  {
    icon: trouble_shoot,
    title: "Troubleshooting & Maintenance",
    desc: "Techniques for optimising and maintaining automation systems.",
  },
];

const marketingModules = [
  {
    icon: seo,
    title: "SEO",
    desc: "Techniques to improve your online visibility and search rankings.",
  },
  {
    icon: social_media,
    title: "Social Media Marketing",
    desc: "Leveraging Facebook, Instagram, and LinkedIn for business growth.",
  },
  {
    icon: ppc,
    title: "PPC Advertising",
    desc: "Maximising ROI on your Google and Meta ad spend.",
  },
  {
    icon: content,
    title: "Content Marketing",
    desc: "Creating engaging, high-impact content that converts.",
  },
  {
    icon: email_icon,
    title: "Email Marketing",
    desc: "Building effective email campaigns to reach your audience.",
  },
  {
    icon: latest_tech,
    title: "Analytics & Insights",
    desc: "Data-driven strategies to measure and improve campaign performance.",
  },
];

const trainMethods = [
  {
    step: "01",
    name: "Requirement Analysis",
    desc: "We study your business goals and identify specific skill gaps in your workforce.",
  },
  {
    step: "02",
    name: "Customised Curriculum",
    desc: "Training modules are designed exclusively for your industry and team profile.",
  },
  {
    step: "03",
    name: "Hands-On Training",
    desc: "Practical sessions using real equipment, live tools, and industry-based scenarios.",
  },
  {
    step: "04",
    name: "Assessment & Evaluation",
    desc: "Structured tests and practical evaluations to measure employee progress.",
  },
  {
    step: "05",
    name: "Continuous Support",
    desc: "Post-training guidance and implementation support to ensure real-world application.",
  },
];

const faqItems = [
  {
    q: "What is corporate training?",
    a: "Corporate training is a professional program designed to improve employee skills, knowledge, and overall performance within an organisation.",
  },
  {
    q: "Do you provide customised training?",
    a: "Yes, we design training programs based on your company's specific requirements, industry, and goals.",
  },
  {
    q: "What training modes are available?",
    a: "We provide flexible training options including online, offline, and on-site corporate training.",
  },
  {
    q: "Do you provide certification?",
    a: "Yes, participants will receive an industry-recognised certification after successful completion.",
  },
  {
    q: "What topics are covered in your training?",
    a: "We offer training in Industrial Automation (PLC, SCADA, HMI) and Digital Marketing (SEO, SMM, PPC, Content Marketing).",
  },
  {
    q: "How long is the training duration?",
    a: "The duration depends on the course and customisation, ranging from a few days to several weeks.",
  },
  {
    q: "Who can attend corporate training programs?",
    a: "Corporate training is designed for employees, teams, and organisations looking to upgrade their technical and professional skills.",
  },
];

// ================================================================
//  REUSABLE COMPONENTS
// ================================================================

// Section Header — same style as Workshop SectionHeader
function SectionHeader({ label, title }) {
  return (
    <div className="mb-5">
      {label && (
        <span
          className="fw-semibold d-flex"
          style={{ fontSize: "20px", color: "#cc0000" }}
        >
          {label}
        </span>
      )}
      <div className="mt-2 cop-tra-titles d-flex">{title}</div>
    </div>
  );
}

// Module Card — same style as Workshop TopicCard
function ModuleCard({ item }) {
  return (
    <motion.div className="col-12 col-md-6 col-lg-4 mb-4" variants={cardPop}>
      <div className="card h-100 border-0 shadow-sm rounded-3 cop-tra-topic-card">
        <div className="card-body p-4 text-center d-flex flex-column">
          {/* <div className="mb-3" style={{ fontSize: "32px" }}>{item.icon}</div> */}
          <center>
            <img src={item.icon} className="mb-3 " style={{ width: "35px" }} />
          </center>
          <h5 className="fw-bold mb-3 cop-tra-topic-title">{item.title}</h5>
          <p className="text-muted flex-grow-1 cop-tra-topic-desc">
            {item.desc}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

// ================================================================
//  MAIN COMPONENT
// ================================================================
function CorporateTrainings() {
  const [meta, setMeta] = useState(null);

  // scroll top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchData = () => {
    const CorporateTrainMeta = data[0]?.corporate_training_page;
    if (CorporateTrainMeta) {
      setMeta(CorporateTrainMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="cop-tra-page">
      {/* ── SEO ──────────────────────────────────────────── */}
      <Helmet>
        <title>{meta ? meta.title : "Corporate Trainings"}</title>
      </Helmet>

      <div className="cop-tra-page">
        {/* ── 1. HERO ────────────────────────────────────── */}
        <section className="cop-tra-hero-section position-relative overflow-hidden">
          <div
            className="cop-tra-hero-bg position-absolute w-100 h-100"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.60), rgba(0,0,0,0.72)), url(${corporate_bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />

          <div className="container position-relative" style={{ zIndex: 2 }}>
            {/* Badge */}
            <motion.div
              className="d-flex align-items-center justify-content-center gap-3 mb-3"
              variants={fadeUp}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.1 }}
            >
              <span className="text-white fw-semibold px-3 py-1 rounded-4 cop-tra-hero-badge">
                Industrial Automation Corporate Training
              </span>
            </motion.div>

            {/* Title */}
            <motion.h1
              className="text-white text-center fw-bold mb-3 cop-tra-hero-title"
              variants={zoomIn}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.25 }}
            >
              Corporate Training Programs.
              <br />
              <span style={{ color: "#cc0000" }}>Empower Your Workforce.</span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p
              className="text-white text-center mx-auto cop-tra-hero-sub"
              variants={fadeUp}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.45 }}
            >
              Customised Industrial Automation & Digital Marketing training
              solutions designed exclusively for your organisation's growth.
            </motion.p>
          </div>
        </section>

        {/* ── 2. ABOUT / INTRO ────────────────────────────── */}
        <div className="container cop-tra-container mb-4 mt-5 mb-md-5 px-3 px-md-4">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={VP}
          >
            <SectionHeader
              label="About Corporate Training"
              title="Tailored Training. Measurable Results. Real Growth."
            />
          </motion.div>

          <div className="row align-items-center g-4">
            <motion.div
              className="col-md-6 col-sm-12"
              variants={fadeLeft}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <img
                src={training_img}
                className="img-fluid rounded-4 w-100"
                alt="Corporate Training at Skimitar Hindusthan"
              />
            </motion.div>

            <motion.div
              className="col-md-6 col-sm-12"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <p>
                At <b>Skimitar Hindusthan</b>, we specialise in providing
                customised corporate training solutions tailored to the unique
                needs of your organisation. Whether you're looking to upskill
                your workforce in <b>Skimitar Industrial Automation</b> or
                enhance your team's expertise in Digital Marketing, we deliver
                impactful training that drives measurable results.
              </p>
              <p>
                Our corporate training programs are built on a foundation of
                real-world experience. Every module is designed by industry
                experts and delivered using practical, hands-on methods —
                ensuring your employees gain skills they can apply immediately
                on the job.
              </p>
              <p>
                We offer flexible delivery modes — online, offline, and on-site
                — so training fits seamlessly into your organisation's workflow
                and schedule.
              </p>
              <p>
                From requirement analysis to post-training support, Skimitar
                Hindusthan is your end-to-end partner in workforce development
                and organisational capability building.
              </p>
            </motion.div>
          </div>
        </div>

        {/* ── 3. WHY CHOOSE US ────────────────────────────── */}
        <section className="py-5 bg_color cop-tra-section-gap">
          <div className="container cop-tra-container">
            <motion.div
              className="mb-5 text-center"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <SectionHeader
                label="Why Us"
                title="Why Choose Skimitar Hindusthan for Corporate Training?"
              />
            </motion.div>

            <motion.div
              className="row g-4"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              {whyChoose.map((item, i) => (
                <motion.div
                  key={i}
                  className="col-md-6 col-lg-4"
                  variants={cardPop}
                >
                  <div className="card h-100 border-0 shadow-sm rounded-3 p-4 text-center cop-tra-card-hover">
                    {/* <div className="mb-3" style={{ fontSize: "32px" }}>{item.icon}</div> */}
                    <center>
                      <img
                        src={item.icon}
                        className="mb-3 "
                        style={{ width: "35px" }}
                      />
                    </center>
                    <h5 className="cop-tra-card-title fw-bold mb-3">
                      {item.title}
                    </h5>
                    <p className="cop-tra-card-des">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* ── 4. INDUSTRIAL AUTOMATION TRAINING ───────────── */}
        <section className="py-5 cop-tra-section-gap">
          <div className="container cop-tra-container">
            <motion.div
              className="mb-5"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <SectionHeader
                label="Training Track 01"
                title="Industrial Automation Corporate Training"
              />
            </motion.div>

            <div className="row align-items-center g-4 mb-5">
              <motion.div
                className="col-md-6"
                variants={fadeLeft}
                initial="hidden"
                whileInView="visible"
                viewport={VP}
              >
                <img
                  src={corporate_about}
                  className="img-fluid rounded-4 w-100"
                  alt="Industrial Automation Corporate Training"
                />
              </motion.div>
              <motion.div
                className="col-md-6"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={VP}
              >
                <p>
                  Equip your team with advanced knowledge and hands-on
                  experience in Industrial Automation. Our training modules are
                  designed for engineers, technicians, and maintenance teams
                  across manufacturing and process industries.
                </p>
                <p>
                  Each session is delivered by certified automation engineers
                  with 10+ years of real-world experience, using actual PLC
                  hardware and live SCADA environments for maximum learning
                  effectiveness.
                </p>
                <p>
                  Training is fully customised to your existing equipment,
                  software platforms, and operational goals — ensuring zero
                  disconnect between classroom learning and shop-floor
                  application.
                </p>
              </motion.div>
            </div>

            {/* Module Cards */}
            <motion.div
              className="row g-4"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              {automationModules.map((item, i) => (
                <ModuleCard key={i} item={item} />
              ))}
            </motion.div>
          </div>
        </section>

        {/* ── 5. DIGITAL MARKETING TRAINING ───────────────── */}
        <section className="py-5 cop-tra-section-gap bg_color">
          <div className="container cop-tra-container">
            <motion.div
              className="mb-5"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <SectionHeader
                label="Training Track 02"
                title="Digital Marketing Corporate Training"
              />
            </motion.div>

            <div className="row align-items-center g-4 mb-5">
              <motion.div
                className="col-md-6"
                variants={fadeLeft}
                initial="hidden"
                whileInView="visible"
                viewport={VP}
              >
                <p>
                  Stay ahead in the digital era by empowering your workforce
                  with cutting-edge Digital Marketing skills. Our programs are
                  built for marketing teams, sales professionals, and business
                  owners looking to grow their online presence.
                </p>
                <p>
                  Every module combines strategic frameworks with hands-on
                  platform training — from Google Ads and Meta Business Suite to
                  GA4 analytics and email automation tools.
                </p>
                <p>
                  We align the curriculum with your business objectives, target
                  audience, and existing digital assets, so your team learns to
                  deliver results — not just concepts.
                </p>
              </motion.div>
              <motion.div
                className="col-md-6"
                variants={fadeLeft}
                initial="hidden"
                whileInView="visible"
                viewport={VP}
              >
                <img
                  src={digital_img}
                  className="img-fluid rounded-4 w-100"
                  alt="Digital Marketing Corporate Training"
                />
              </motion.div>
            </div>

            {/* Module Cards */}
            <motion.div
              className="row g-4"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              {marketingModules.map((item, i) => (
                <ModuleCard key={i} item={item} />
              ))}
            </motion.div>
          </div>
        </section>

        {/* ── 6. TRAINING METHODOLOGY ─────────────────────── */}
        <section className="py-5 cop-tra-section-gap">
          <div className="container cop-tra-container">
            <motion.div
              className="mb-5 text-center"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <SectionHeader
                label="Our Approach"
                title="How We Deliver Corporate Training"
              />
            </motion.div>

            <motion.div
              className="row g-4"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              {trainMethods.map((item, i) => (
                <motion.div
                  key={i}
                  className="col-md-6 col-lg-4 mb-3"
                  variants={cardPop}
                >
                  <div className="card h-100 border-0 shadow-sm rounded-3 p-4 cop-tra-card-hover">
                    <div className="d-flex align-items-start gap-3">
                      <div className="cop-tra-step-num flex-shrink-0">
                        {item.step}
                      </div>
                      <div>
                        <h5 className="fw-bold mb-2 cop-tra-card-title">
                          {item.name}
                        </h5>
                        <p className="mb-0 cop-tra-card-des">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* ── 7. JOIN LEADING COMPANIES ───────────────────── */}
        <section className="py-5 cop-tra-section-gap bg_color">
          <div className="container cop-tra-container">
            <motion.div
              className="text-center mb-4"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <SectionHeader
                label="Our Reach"
                title="Join Leading Companies Trusting Skimitar Hindusthan"
              />
            </motion.div>

            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <p>
                Empower your workforce with the skills they need to excel in
                their roles. Skimitar Hindusthan has earned the trust of leading
                companies across industries by delivering innovative and
                reliable training solutions tailored to modern business
                challenges.
              </p>
              <p>
                Renowned for its commitment to quality, efficiency, and
                excellence, Skimitar Hindusthan empowers organisations to
                achieve their goals with cutting-edge programs and a
                customer-centric approach that ensures long-term value. Join the
                growing network of industry leaders who trust Skimitar
                Hindusthan to drive innovation and growth in today's competitive
                landscape.
              </p>
            </motion.div>
          </div>
        </section>

        {/* ── 8. FAQ ──────────────────────────────────────── */}
        <section className="py-5 cop-tra-section-gap">
          <div className="container cop-tra-container">
            <motion.div
              className="mb-5 text-center"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              <SectionHeader label="FAQ" title="Frequently Asked Questions" />
            </motion.div>

            <motion.div
              className="accordion cop-tra-accordion"
              id="corpFaqAccordion"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={VP}
            >
              {faqItems.map((item, i) => (
                <motion.div
                  className="accordion-item border-0 shadow-sm mb-3"
                  key={i}
                  variants={fadeUp}
                >
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-semibold ${i !== 0 ? "collapsed" : ""}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#corpFaq${i}`}
                    >
                      {item.q}
                    </button>
                  </h2>
                  <div
                    id={`corpFaq${i}`}
                    className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                    data-bs-parent="#corpFaqAccordion"
                  >
                    <div
                      className="accordion-body"
                      style={{ fontSize: "15px", lineHeight: "1.75" }}
                    >
                      {item.a}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* ── 9. CTA ──────────────────────────────────────── */}
        {/* <motion.section
          style={{ marginTop: "100px" }}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={VP}
        >
          <div className="p-5 cop-tra-cta-wrap">
            <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
              <div
                className="bg-light"
                style={{ width: "40px", height: "1px" }}
              />
              <span
                className="text-uppercase fw-semibold text-white text-opacity-75"
                style={{
                  letterSpacing: "2px",
                  whiteSpace: "nowrap",
                  fontSize: "13px",
                }}
              >
                Build a Stronger Workforce
              </span>
              <div
                className="bg-light"
                style={{ width: "40px", height: "1px" }}
              />
            </div>

            <div className="row g-4 align-items-center">
              <motion.div
                className="col-lg-7 text-center text-lg-start"
                variants={fadeLeft}
                initial="hidden"
                whileInView="visible"
                viewport={VP}
              >
                <h2 className="fw-bolder text-white text-uppercase mb-3 cop-tra-cta-title">
                  Ready to Upskill Your Team with <b>Skimitar Hindusthan?</b>
                </h2>
                <p
                  className="text-white text-opacity-75 mb-0"
                  style={{ lineHeight: "1.75" }}
                >
                  Contact us today to discuss your corporate training
                  requirements. Our experts will design a custom program that
                  fits your team, timeline, and business objectives.
                </p>
              </motion.div>

              <motion.div
                className="col-lg-5"
                variants={fadeRight}
                initial="hidden"
                whileInView="visible"
                viewport={VP}
              >
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                  <button className="btn cop-tra-btn-white px-4 py-3 fw-bold text-uppercase">
                    Get a Training Quote →
                  </button>
                  <button className="btn cop-tra-btn-ghost px-4 py-3 fw-bold text-uppercase">
                    📞 (+91) 8428010909
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.section> */}
      </div>
    </div>
  );
}

export default CorporateTrainings;
